import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import Matematikspillet from "./Matematikspillet";
import ErrorBoundary from "./ErrorBoundary";
import VersionInfo from "./components/VersionInfo";

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <ErrorBoundary>
      <Matematikspillet />
      <VersionInfo />
    </ErrorBoundary>
  </React.StrictMode>
);
